<script>
  import {
    pop
  } from 'svelte-spa-router'
  export let invert
</script>

<button on:click="{pop}" type="button" aria-label="Go Back">
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g id="arrow_back_ios_24px">
      <path id="icon/navigation/arrow_back_ios_24px" d="M17.835 3.87L16.055 2.1L6.16504 12L16.065 21.9L17.835 20.13L9.70504 12L17.835 3.87Z" fill={invert ? "#202020" : "#FDFFFC" } />
    </g>
  </svg>
</button>

<style>
  button {
    width: 40px;
    background: none;
    outline: none;
    border: none;
  }
</style>
